// import React, { useState, useEffect } from "react";
// import axios from 'axios';
// import { format, parse } from 'date-fns';
// import { BaseUrl } from "../App";
// import { Circles } from 'react-loader-spinner';
// import { FadeLoader } from 'react-spinners';


// // Responsive ColorInput component
// const ColorInput = ({ label, value, onChange }) => (
//   <div className="mb-4">
//     <label className="block text-sm text-gray-600 mb-1">{label}</label>
//     <div className="flex items-center">
//       <input
//         type="color"
//         value={value}
//         onChange={onChange}
//         className="w-10 h-10 rounded border border-gray-300 cursor-pointer"
//       />
//       <input
//         type="text"
//         value={value}
//         onChange={onChange}
//         className="ml-2 w-full px-2 py-1 border border-gray-300 rounded"
//         placeholder="Enter color code"
//       />
//     </div>
//   </div>
// );

// // Responsive Toggle component
// const Toggle = ({ label, isOn, onToggle }) => (
//   <div className="flex items-center justify-between mb-3 p-3 bg-gray-50 rounded-md">
//     <span className="text-gray-700 text-sm">{label}</span>
//     <label className="relative inline-flex items-center cursor-pointer">
//       <input
//         type="checkbox"
//         value=""
//         className="sr-only peer"
//         checked={isOn}
//         onChange={onToggle}
//       />
//       <div className="group peer bg-white rounded-full duration-300 w-12 h-6 ring-2 ring-red-500 after:duration-300 after:bg-red-500 peer-checked:after:bg-green-500 peer-checked:ring-green-500 after:rounded-full after:absolute after:h-4 after:w-4 after:top-1 after:left-1 peer-checked:after:translate-x-6 peer-hover:after:scale-95"></div>
//     </label>
//   </div>
// );

// // Card component for wrapping settings sections
// const SettingsCard = ({ title, children }) => (
//   <div className="mb-6 p-4 bg-white rounded-md shadow-sm border border-gray-100">
//     {title && <h3 className="text-lg font-semibold text-gray-700 mb-4 border-b pb-2">{title}</h3>}
//     {children}
//   </div>
// );

// const Appearance = () => {
//   const [primaryColor, setPrimaryColor] = useState("#003b46");
//   const [secondaryColor, setSecondaryColor] = useState("#187d90");
//   const [textColor, setTextColor] = useState("#ffffff");
//   const [bgTextColor, setBgTextColor] = useState("#ffffff");
//   const [adminPrimaryColor, setAdminPrimaryColor] = useState("#003b46");
//   const [adminSecondaryColor, setAdminSecondaryColor] = useState("#187d90");
//   const [adminTextColor, setAdminTextColor] = useState("#ffffff");
//   const [hideBookedTime, setHideBookedTime] = useState(false);
//   const [guestCheckout, setGuestCheckout] = useState(false);
//   const [existingNewCheckout, setExistingNewCheckout] = useState(true);
//   const [scrollableCart, setScrollableCart] = useState(true);
//   const [displayTimeDuration, setDisplayTimeDuration] = useState(true);
//   const [timeFormat, setTimeFormat] = useState("12");
//   const [datePickerFormat, setDatePickerFormat] = useState("dd-mm-yyyy");
//   const [countryCode, setCountryCode] = useState("");
//   const [font, setFont] = useState("Open Sans");
//   const [customCss, setCustomCss] = useState("");
//   const [loader, setLoader] = useState("default");
//   const [customCssLoader, setCustomCssLoader] = useState("");
//   const [calendarView, setCalendarView] = useState("month");
//   const [calendarStartDay, setCalendarStartDay] = useState("0");
//   const [loaderType, setLoaderType] = useState("css");
//   const [cssCode, setCssCode] = useState("");
//   const [showGifLoader, setShowGifLoader] = useState(false);
//   const [gifFile, setGifFile] = useState(null);
//   const [loginPageFile, setLoginPageFile] = useState(null);
//   const [frontPageFile, setFrontPageFile] = useState(null);
//   const [settings, setSettings] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [isSaving, setIsSaving] = useState(false);
//   const [saveError, setSaveError] = useState(null);
//   const [saveSuccess, setSaveSuccess] = useState(false);
//   const [successMessage, setSuccessMessage] = useState("")

//   useEffect(() => {
//     fetchSettings();
//   }, []);

//   const fetchSettings = async () => {
//     setLoading(true);
//     try {
//       const response = await axios.post(`${BaseUrl}/backend/api/settings.php`, {
//         action: "get_all_settings",
//         api_key: "1"
//       });
      
//       if (response.data.status === "true") {
//         const fetchedSettings = response.data.response.reduce((acc, item) => {
//           acc[item.option_name] = item.option_value;
//           return acc;
//         }, {});
//         setSettings(fetchedSettings);
//         updateStateFromSettings(fetchedSettings);
//       } else {
//         setError("Failed to fetch settings");
//       }
//     } catch (err) {
//       setError("An error occurred while fetching settings");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const updateStateFromSettings = (fetchedSettings) => {
//     setPrimaryColor(fetchedSettings.ct_primary_color || "#003b46");
//     setSecondaryColor(fetchedSettings.ct_secondary_color || "#187d90");
//     setTextColor(fetchedSettings.ct_text_color || "#666666");
//     setBgTextColor(fetchedSettings.ct_text_color_on_bg || "#ffffff");
//     setAdminPrimaryColor(fetchedSettings.ct_primary_color_admin || "#003b46");
//     setAdminSecondaryColor(fetchedSettings.ct_secondary_color_admin || "#187d90");
//     setAdminTextColor(fetchedSettings.ct_text_color_admin || "#ffffff");
//     setHideBookedTime(fetchedSettings.ct_hide_faded_already_booked_time_slots === "Y");
//     setGuestCheckout(fetchedSettings.ct_guest_user_checkout === "on");
//     setExistingNewCheckout(fetchedSettings.ct_existing_and_new_user_checkout === "on");
//     setTimeFormat(fetchedSettings.ct_time_format || "12");
//     setScrollableCart(fetchedSettings.ct_cart_scrollable === "Y");
//     setDisplayTimeDuration(fetchedSettings.ct_show_time_duration === "Y");
//     setDatePickerFormat(fetchedSettings.ct_date_picker_date_format || "dd-mm-yyyy"); 
//     setCountryCode(fetchedSettings.ct_phone_display_country_code || "");
//     setFont(fetchedSettings.ct_frontend_fonts || "Open Sans");
//     setCustomCss(fetchedSettings.ct_custom_css || "");
//     setCalendarView(fetchedSettings.ct_calendar_defaultView || "month");
//     setCalendarStartDay(fetchedSettings.ct_calendar_firstDay || "0");
//     setLoader(fetchedSettings.ct_loader || "default");
//     setCustomCssLoader(fetchedSettings.ct_custom_css_loader || "");
    
//     if (fetchedSettings.ct_loader === "css") {
//       setLoaderType("css");
//       setCssCode(fetchedSettings.ct_custom_css_loader || "");
//     } else if (fetchedSettings.ct_loader === "gif") {
//       setLoaderType("gif");
//       setShowGifLoader(true);
//     } else {
//       setLoaderType("default");
//     }
//   };

//   const handleSave = async () => {
//     setIsSaving(true);
//         setLoading(true);

//     setSaveError(null);
//     setSaveSuccess(false);

//     console.log(primaryColor)

//     const settingsToUpdate = [
//       { option_name: "ct_primary_color", option_value: primaryColor },
//       { option_name: "ct_secondary_color", option_value: secondaryColor },
//       { option_name: "ct_text_color", option_value: textColor },
//       { option_name: "ct_text_color_on_bg", option_value: bgTextColor },
//       { option_name: "ct_primary_color_admin", option_value: adminPrimaryColor },
//       { option_name: "ct_secondary_color_admin", option_value: adminSecondaryColor },
//       { option_name: "ct_text_color_admin", option_value: adminTextColor },
//       { option_name: "ct_hide_faded_already_booked_time_slots", option_value: hideBookedTime ? "Y" : "N" },
//       { option_name: "ct_guest_user_checkout", option_value: guestCheckout ? "on" : "off" },
//       { option_name: "ct_existing_and_new_user_checkout", option_value: existingNewCheckout ? "on" : "off" },
//       { option_name: "ct_time_format", option_value: timeFormat },
//       { option_name: "ct_cart_scrollable", option_value: scrollableCart ? "Y" : "N" },
//       { option_name: "ct_show_time_duration", option_value: displayTimeDuration ? "Y" : "N" },
//       { option_name: "ct_date_picker_date_format", option_value: datePickerFormat }, 
//       { option_name: "ct_phone_display_country_code", option_value: countryCode },
//       { option_name: "ct_frontend_fonts", option_value: font },
//       { option_name: "ct_custom_css", option_value: customCss },
//       { option_name: "ct_calendar_defaultView", option_value: calendarView },
//       { option_name: "ct_calendar_firstDay", option_value: calendarStartDay },
//       { option_name: "ct_loader", option_value: loaderType },
//       { option_name: "ct_custom_css_loader", option_value: loaderType === "css" ? cssCode : "" },
//     ];

//     console.log(settingsToUpdate)

//     try {
//       for (const setting of settingsToUpdate) {
//         await axios.post(`${BaseUrl}/backend/api/settings.php`, {
//           action: "update_setting",
//           api_key: "1", 
//           option_name: setting.option_name,
//           option_value: setting.option_value
//         });
//       }
//       setSaveSuccess(true);
//     } catch (error) {
//       console.error("Error saving settings:", error);
//       setSaveError("Failed to save settings. Please try again.");
//     } finally {
//       setIsSaving(false);
     
//       setLoading(false);
    
//     }
//   };

//   const handleGifFileChange = (event) => {
//     const file = event.target.files[0];
//     if (file && file.type === "image/gif") {
//       setGifFile(URL.createObjectURL(file));
//     } else {
//       alert("Please select a valid GIF file.");
//       setGifFile(null);
//     }
//   };

//   const resetColors = () => {
//     setPrimaryColor("#0834e2");
//     setSecondaryColor("#187d90");
//     setTextColor("#ffffff");
//     setBgTextColor("#ffffff");
//     setAdminPrimaryColor("#003b46");
//     setAdminSecondaryColor("#187d90");
//     setAdminTextColor("#ffffff");
//   };

//   const handleLoginPageFileChange = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       setLoginPageFile(file);
//     }
//   };

//   const handleFrontPageFileChange = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       setFrontPageFile(file);
//     }
//   };

//   const restoreLoginPageDefault = () => {
//     setLoginPageFile(null);
//   };

//   const restoreFrontPageDefault = () => {
//     setFrontPageFile(null);
//   };

//   const formatDate = (date, formatString) => {
//     const parsedDate = typeof date === 'string' ? parse(date, 'd-M-yyyy', new Date()) : date;
//     switch (formatString) {
//       case "dd-mm-yyyy":
//         return format(parsedDate, 'dd-MM-yyyy');
//       case "d-mm-yyyy":
//         return format(parsedDate, 'd-MM-yyyy');
//       case "dd-m-yyyy":
//         return format(parsedDate, 'dd-MMMM-yyyy');
//       default:
//         return format(parsedDate, 'dd-MM-yyyy');
//     }
//   };

//   if (error) return (
//     <div className="p-4 text-center text-red-600 bg-red-50 rounded-md">
//       Error: {error}
//     </div>
//   );

//   return (
//     <div className="relative min-h-screen">
//     {/* Loading Indicator */}
//       {loading && (
//            <div className="fixed inset-0 flex items-center justify-center z-50">
//              <div className="flex flex-col items-center p-3 bg-black border border-white rounded-2xl">
//                <FadeLoader 
//                  height={15}
//                  width={5}
//                  color="#ffffff"
//                  ariaLabel="loading"
//                />
//                <h1 className="mt-1 text-lg text-white">Please wait...</h1>
//              </div>
//            </div>
//          )}
//            {saveSuccess && (
//           <div className="mt-4 p-3 bg-green-100 text-green-700 rounded-md flex items-center">
//             <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
//               <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
//             </svg>
//             Settings saved successfully!
//           </div>
//         )}

//         {saveError && (
//           <div className="mt-4 p-3 bg-red-100 text-red-700 rounded-md flex items-center">
//             <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
//               <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
//             </svg>
//             {saveError}
//           </div>
//         )}
         
//     <div className="container mx-auto px-4 md:px-6 lg:px-8  xl:px-24 py-6 ">
//       <div className="bg-white shadow-md rounded-lg p-4 md:p-6 mb-6">
//         <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4 md:mb-6 border-b pb-2">
//           Appearance Settings
//         </h2>
//         <div className="mt-6 flex justify-center md:justify-end">
//           <button 
//             className={`bg-green-600 text-white px-6 py-3 rounded-md shadow hover:bg-green-700 transition w-full md:w-auto ${isSaving ? 'opacity-50 cursor-not-allowed' : ''}`}
//             onClick={handleSave}
//             disabled={isSaving}
//           >
//             {isSaving ? 'Saving...' : 'Save Settings'}
//           </button>
//         </div>

//         <SettingsCard title="Color Scheme">
//           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
//             <ColorInput
//               label="Primary Color"
//               value={primaryColor}
//               onChange={(e) => setPrimaryColor(e.target.value)}
//             />
//             <ColorInput
//               label="Secondary Color"
//               value={secondaryColor}
//               onChange={(e) => setSecondaryColor(e.target.value)}
//             />
//             <ColorInput
//               label="Text Color"
//               value={textColor}
//               onChange={(e) => setTextColor(e.target.value)}
//             />
//             <ColorInput
//               label="Text Color on bg"
//               value={bgTextColor}
//               onChange={(e) => setBgTextColor(e.target.value)}
//             />
//           </div>
//         </SettingsCard>

//         <SettingsCard title="Admin Area Color Scheme">
//           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
//             <ColorInput
//               label="Primary Color"
//               value={adminPrimaryColor}
//               onChange={(e) => setAdminPrimaryColor(e.target.value)}
//             />
//             <ColorInput
//               label="Secondary Color"
//               value={adminSecondaryColor}
//               onChange={(e) => setAdminSecondaryColor(e.target.value)}
//             />
//             <ColorInput
//               label="Text Color"
//               value={adminTextColor}
//               onChange={(e) => setAdminTextColor(e.target.value)}
//             />
//           </div>
//           <button
//             onClick={resetColors}
//             className="mt-4 bg-gray-100 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-200 transition"
//           >
//             Reset Colors
//           </button>
//         </SettingsCard>

//         <SettingsCard title="Booking Options">
//           <Toggle
//             label="Hide faded already booked time slots"
//             isOn={hideBookedTime}
//             onToggle={() => setHideBookedTime(!hideBookedTime)}
//           />
//           <Toggle
//             label="Guest user checkout"
//             isOn={guestCheckout}
//             onToggle={() => setGuestCheckout(!guestCheckout)}
//           />
//           <Toggle
//             label="Existing & new user checkout"
//             isOn={existingNewCheckout}
//             onToggle={() => setExistingNewCheckout(!existingNewCheckout)}
//           />
//           <Toggle
//             label="Scrollable Cart"
//             isOn={scrollableCart}
//             onToggle={() => setScrollableCart(!scrollableCart)}
//           />
//           <Toggle
//             label="Display Time Duration on Summary"
//             isOn={displayTimeDuration}
//             onToggle={() => setDisplayTimeDuration(!displayTimeDuration)}
//           />
//         </SettingsCard>

//         <SettingsCard title="Date & Time Settings">
//           <div className="space-y-4">
//             <div className="mb-4">
//               <label className="block text-sm text-gray-600 mb-2">Time Format</label>
//               <select
//                 value={timeFormat}
//                 onChange={(e) => setTimeFormat(e.target.value)}
//                 className="w-full border rounded-md px-3 py-2 bg-white"
//               >
//                 <option value="12">12 Hours</option>
//                 <option value="24">24 Hours</option>
//               </select>
//             </div>

//             <div className="mb-4">
//               <label className="block text-sm text-gray-600 mb-2">Date-Picker Format</label>
//               <select
//                 value={datePickerFormat}
//                 onChange={(e) => setDatePickerFormat(e.target.value)}
//                 className="w-full border rounded-md px-3 py-2 bg-white"
//               >
//                 <option value="dd-mm-yyyy">dd-mm-yyyy (eg. {formatDate(new Date(), "dd-mm-yyyy")})</option>
//                 <option value="d-mm-yyyy">d-mm-yyyy (eg. {formatDate(new Date(), "d-mm-yyyy")})</option>
//                 <option value="dd-m-yyyy">dd-m-yyyy (eg. {formatDate(new Date(), "dd-m-yyyy")})</option>
//               </select>
//             </div>

//             <div className="mb-4">
//               <label className="block text-sm text-gray-600 mb-2">Country Code</label>
//               <select
//                 value={countryCode}
//                 onChange={(e) => setCountryCode(e.target.value)}
//                 className="w-full border rounded-md px-3 py-2 bg-white"
//               >
//                 <option>Nothing selected</option>
//                 <option value="us">United States</option>
//                 <option value="in">India</option>
//                 <option value="uk">United Kingdom</option>
//                 <option value="au">Australia</option>
//               </select>
//             </div>
//           </div>
//         </SettingsCard>

//         <SettingsCard title="Font Settings">
//           <div className="mb-4">
//             <label className="block text-sm text-gray-600 mb-2">Frontend Fonts</label>
//             <select
//               value={font}
//               onChange={(e) => setFont(e.target.value)}
//               className="w-full border rounded-md px-3 py-2 bg-white"
//             >
//               <option value="Open Sans">Open Sans</option>
//               <option value="Roboto">Roboto</option>
//               <option value="Arial">Arial</option>
//             </select>
//           </div>

//           <div className="mb-4">
//             <label className="block text-sm text-gray-600 mb-2">Custom CSS</label>
//             <textarea
//               value={customCss}
//               onChange={(e) => setCustomCss(e.target.value)}
//               className="w-full border rounded-md px-3 py-2"
//               rows="4"
//               placeholder="Enter custom CSS here..."
//             ></textarea>
//           </div>
//         </SettingsCard>

//         <SettingsCard title="File Uploads">
//           <div className="space-y-6">
//             <div className="mb-4">
//               <label className="block text-sm text-gray-600 mb-2">Login Page Background</label>
//               <input
//                 type="file"
//                 className="block w-full border rounded-md p-2 text-sm"
//                 onChange={handleLoginPageFileChange}
//               />
//               {loginPageFile && (
//                 <div className="mt-2 flex flex-col sm:flex-row sm:items-center gap-2">
//                   <button
//                     onClick={restoreLoginPageDefault}
//                     className="bg-blue-500 text-white px-4 py-2 rounded-md text-sm"
//                   >
//                     Restore Default
//                   </button>
//                   <span className="text-gray-600 text-sm truncate">{loginPageFile.name}</span>
//                 </div>
//               )}
//             </div>

//             <div className="mb-4">
//               <label className="block text-sm text-gray-600 mb-2">Front Page Background</label>
//               <input
//                 type="file"
//                 className="block w-full border rounded-md p-2 text-sm"
//                 onChange={handleFrontPageFileChange}
//               />
//               {frontPageFile && (
//                 <div className="mt-2 flex flex-col sm:flex-row sm:items-center gap-2">
//                   <button
//                     onClick={restoreFrontPageDefault}
//                     className="bg-blue-500 text-white px-4 py-2 rounded-md text-sm"
//                   >
//                     Restore Default
//                   </button>
//                   <span className="text-gray-600 text-sm truncate">{frontPageFile.name}</span>
//                 </div>
//               )}
//             </div>
//           </div>
//         </SettingsCard>

//         <SettingsCard title="Loader Settings">
//           <div className="space-y-4">
//             <div className="mb-4">
//               <label className="block text-sm text-gray-600 mb-2">Loader Type</label>
//               <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
//                 <label className="flex items-center p-2 border rounded-md">
//                   <input
//                     type="radio"
//                     value="css"
//                     checked={loaderType === "css"}
//                     onChange={() => {
//                       setLoaderType("css");
//                       setCssCode(customCssLoader || "");
//                       setShowGifLoader(false);
//                       setGifFile(null);
//                     }}
//                     className="mr-2"
//                   />
//                   <span>CSS Loader</span>
//                 </label>
//                 <label className="flex items-center p-2 border rounded-md">
//                   <input
//                     type="radio"
//                     value="gif"
//                     checked={loaderType === "gif"}
//                     onChange={() => {
//                       setLoaderType("gif");
//                       setCssCode("");
//                       setShowGifLoader(true);
//                     }}
//                     className="mr-2"
//                   />
//                   <span>GIF Loader</span>
//                 </label>
//                 <label className="flex items-center p-2 border rounded-md">
//                   <input
//                     type="radio"
//                     value="default"
//                     checked={loaderType === "default"}
//                     onChange={() => {
//                       setLoaderType("default");
//                       setCssCode("");
//                       setShowGifLoader(false);
//                       setGifFile(null);
//                     }}
//                     className="mr-2"
//                   />
//                   <span>Default Loader</span>
//                 </label>
//               </div>
//             </div>

//             {loaderType === "css" && (
//               <div className="mb-4">
//                 <label className="block text-sm text-gray-600 mb-2">
//                   Custom CSS Loader
//                 </label>
//                 <textarea
//                   value={cssCode}
//                   onChange={(e) => setCssCode(e.target.value)}
//                   className="w-full border rounded-md px-3 py-2"
//                   rows="4"
//                   placeholder="Enter custom CSS here..."
//                 ></textarea>
//               </div>
//             )}

//             {loaderType === "gif" && showGifLoader && (
//               <div className="mb-4">
//                 <label className="block text-sm text-gray-600 mb-2">
//                   Select GIF Loader
//                 </label>
//                 <input
//                   type="file"
//                   accept="image/gif"
//                   onChange={handleGifFileChange}
//                   className="w-full border rounded-md p-2"
//                 />
//                 {gifFile && (
//                   <div className="flex justify-center mt-4">
//                     <img
//                       src={gifFile}
//                       alt="GIF Loader"
//                       className="w-16 h-16 object-contain"
//                     />
//                   </div>
//                 )}
//               </div>
//             )}
//           </div>
//         </SettingsCard>

//         <SettingsCard title="Calendar Settings">
//           <div className="space-y-4">
//             <div className="mb-4">
//               <label className="block text-sm text-gray-600 mb-2">
//                 Calendar Default View
//               </label>
//               <select
//                 value={calendarView}
//                 onChange={(e) => setCalendarView(e.target.value)}
//                 className="w-full border rounded-md px-3 py-2 bg-white"
//               >
//                 <option value="month">Month</option>
//                 <option value="agendaWeek">Week</option>
//                 <option value="agendaDay">Day</option>
//               </select>
//             </div>

//             <div className="mb-4">
//               <label className="block text-sm text-gray-600 mb-2">
//                 Calendar First Day
//               </label>
//               <select
//                 value={calendarStartDay}
//                 onChange={(e) => setCalendarStartDay(e.target.value)}
//                 className="w-full border rounded-md px-3 py-2 bg-white"
//               >
//                 <option value="0">Sunday</option>
//                 <option value="1">Monday</option>
//               </select>
//             </div>
//           </div>
//         </SettingsCard>

//         <div className="mt-6">
//           <button 
//             className={`bg-green-600 text-white px-6 py-3 rounded-md shadow hover:bg-green-700 transition w-full md:w-auto ${isSaving ? 'opacity-50 cursor-not-allowed' : ''}`}
//             onClick={handleSave}
//             disabled={isSaving}
//           >
//             {isSaving ? 'Saving...' : 'Save Settings'}
//           </button>
//         </div>

      
//       </div>
//     </div>
       
//   </div>
//   );
// };

// export default Appearance;
























import React, { useState, useEffect } from "react";
import axios from 'axios';
import { format, parse } from 'date-fns';
import { BaseUrl } from "../App";
// import { Circles } from 'react-loader-spinner';
import { FadeLoader } from 'react-spinners';
// Responsive ColorInput component
const ColorInput = ({ label, value, onChange }) => (
  <div className="mb-4">
    <label className="block text-sm text-gray-600 mb-1">{label}</label>
    <div className="flex items-center">
      <input
        type="color"
        value={value}
        onChange={onChange}
        className="w-10 h-10 rounded border border-gray-300 cursor-pointer"
      />
      <input
        type="text"
        value={value}
        onChange={onChange}
        className="ml-2 w-full px-2 py-1 border border-gray-300 rounded"
        placeholder="Enter color code"
      />
    </div>
  </div>
);

// Responsive Toggle component
const Toggle = ({ label, isOn, onToggle }) => (
  <div className="flex items-center justify-between mb-3 p-3 bg-gray-50 rounded-md">
    <span className="text-gray-700  text-sm">{label}</span>
    <label className="relative inline-flex items-center cursor-pointer">
      <input
        type="checkbox"
        value=""
        className="sr-only peer"
        checked={isOn}
        onChange={onToggle}
      />
      <div className="group peer bg-white rounded-full duration-300 w-12 h-6 ring-2 ring-red-500 after:duration-300 after:bg-red-500 peer-checked:after:bg-green-500 peer-checked:ring-green-500 after:rounded-full after:absolute after:h-4 after:w-4 after:top-1 after:left-1 peer-checked:after:translate-x-6 peer-hover:after:scale-95"></div>
    </label>
  </div>
);

// Card component for wrapping settings sections
const SettingsCard = ({ title, children }) => (
  <div className="mb-6 p-4 bg-gray-200 rounded-md shadow-sm border  border-gray-100">
    {title && <h3 className="text-lg font-semibold text-gray-700  mb-4 border-b pb-2">{title}</h3>}
    {children}
  </div>
);

const Appearance = () => {
  const [primaryColor, setPrimaryColor] = useState("#0011ff");
  const [secondaryColor, setSecondaryColor] = useState("#187d90");
  const [textColor, setTextColor] = useState("#ffffff");
  const [bgTextColor, setBgTextColor] = useState("#ffffff");
  const [adminPrimaryColor, setAdminPrimaryColor] = useState("#0011ff");
  const [adminSecondaryColor, setAdminSecondaryColor] = useState("#187d90");
  const [adminTextColor, setAdminTextColor] = useState("#ffffff");
  const [hideBookedTime, setHideBookedTime] = useState(false);
  const [guestCheckout, setGuestCheckout] = useState(false);
  const [existingNewCheckout, setExistingNewCheckout] = useState(true);
  const [scrollableCart, setScrollableCart] = useState(true);
  const [displayTimeDuration, setDisplayTimeDuration] = useState(true);
  const [timeFormat, setTimeFormat] = useState("12");
  const [datePickerFormat, setDatePickerFormat] = useState("dd-mm-yyyy");
  const [countryCode, setCountryCode] = useState("");
  const [font, setFont] = useState("Open Sans");
  const [customCss, setCustomCss] = useState("");
  const [loader, setLoader] = useState("default");
  const [customCssLoader, setCustomCssLoader] = useState("");
  const [calendarView, setCalendarView] = useState("month");
  const [calendarStartDay, setCalendarStartDay] = useState("0");
  const [loaderType, setLoaderType] = useState("css");
  const [cssCode, setCssCode] = useState("");
  const [showGifLoader, setShowGifLoader] = useState(false);
  const [gifFile, setGifFile] = useState(null);
  const [loginPageFile, setLoginPageFile] = useState(null);
  const [frontPageFile, setFrontPageFile] = useState(null);
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [saveError, setSaveError] = useState(null);
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("")

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/settings.php`, {
        action: "get_all_settings",
        api_key: "1"
      });
      
      if (response.data.status === "true") {
        const fetchedSettings = response.data.response.reduce((acc, item) => {
          acc[item.option_name] = item.option_value;
          return acc;
        }, {});
        setSettings(fetchedSettings);
        updateStateFromSettings(fetchedSettings);
      } else {
        setError("Failed to fetch settings");
      }
    } catch (err) {
      setError("An error occurred while fetching settings");
    } finally {
      setLoading(false);
    }
  };

  const updateStateFromSettings = (fetchedSettings) => {
    setPrimaryColor(fetchedSettings.ct_primary_color || "#0011ff");
    setSecondaryColor(fetchedSettings.ct_secondary_color || "#187d90");
    setTextColor(fetchedSettings.ct_text_color || "#ffffff");
    setBgTextColor(fetchedSettings.ct_text_color_on_bg || "#ffffff");
    setAdminPrimaryColor(fetchedSettings.ct_primary_color_admin || "#0011ff");
    setAdminSecondaryColor(fetchedSettings.ct_secondary_color_admin || "#187d90");
    setAdminTextColor(fetchedSettings.ct_text_color_admin || "#ffffff");
    setHideBookedTime(fetchedSettings.ct_hide_faded_already_booked_time_slots === "Y");
    setGuestCheckout(fetchedSettings.ct_guest_user_checkout === "on");
    setExistingNewCheckout(fetchedSettings.ct_existing_and_new_user_checkout === "on");
    setTimeFormat(fetchedSettings.ct_time_format || "12");
    setScrollableCart(fetchedSettings.ct_cart_scrollable === "Y");
    setDisplayTimeDuration(fetchedSettings.ct_show_time_duration === "Y");
    setDatePickerFormat(fetchedSettings.ct_date_picker_date_format || "dd-mm-yyyy"); 
    setCountryCode(fetchedSettings.ct_phone_display_country_code || "");
    setFont(fetchedSettings.ct_frontend_fonts || "Open Sans");
    setCustomCss(fetchedSettings.ct_custom_css || "");
    setCalendarView(fetchedSettings.ct_calendar_defaultView || "month");
    setCalendarStartDay(fetchedSettings.ct_calendar_firstDay || "0");
    setLoader(fetchedSettings.ct_loader || "default");
    setCustomCssLoader(fetchedSettings.ct_custom_css_loader || "");
    
    if (fetchedSettings.ct_loader === "css") {
      setLoaderType("css");
      setCssCode(fetchedSettings.ct_custom_css_loader || "");
    } else if (fetchedSettings.ct_loader === "gif") {
      setLoaderType("gif");
      setShowGifLoader(true);
    } else {
      setLoaderType("default");
    }
  };

  const handleSave = async () => {
    setIsSaving(true);
        setLoading(true);

    setSaveError(null);
    setSaveSuccess(false);

    const settingsToUpdate = [
      { option_name: "ct_primary_color", option_value: primaryColor },
      { option_name: "ct_secondary_color", option_value: secondaryColor },
      { option_name: "ct_text_color", option_value: textColor },
      { option_name: "ct_text_color_on_bg", option_value: bgTextColor },
      { option_name: "ct_primary_color_admin", option_value: adminPrimaryColor },
      { option_name: "ct_secondary_color_admin", option_value: adminSecondaryColor },
      { option_name: "ct_text_color_admin", option_value: adminTextColor },
      { option_name: "ct_hide_faded_already_booked_time_slots", option_value: hideBookedTime ? "Y" : "N" },
      { option_name: "ct_guest_user_checkout", option_value: guestCheckout ? "on" : "off" },
      { option_name: "ct_existing_and_new_user_checkout", option_value: existingNewCheckout ? "on" : "off" },
      { option_name: "ct_time_format", option_value: timeFormat },
      { option_name: "ct_cart_scrollable", option_value: scrollableCart ? "Y" : "N" },
      { option_name: "ct_show_time_duration", option_value: displayTimeDuration ? "Y" : "N" },
      { option_name: "ct_date_picker_date_format", option_value: datePickerFormat }, 
      { option_name: "ct_phone_display_country_code", option_value: countryCode },
      { option_name: "ct_frontend_fonts", option_value: font },
      { option_name: "ct_custom_css", option_value: customCss },
      { option_name: "ct_calendar_defaultView", option_value: calendarView },
      { option_name: "ct_calendar_firstDay", option_value: calendarStartDay },
      { option_name: "ct_loader", option_value: loaderType },
      { option_name: "ct_custom_css_loader", option_value: loaderType === "css" ? cssCode : "" },
    ];

    try {
      for (const setting of settingsToUpdate) {
        await axios.post(`${BaseUrl}/backend/api/settings.php`, {
          action: "update_setting",
          api_key: "1", 
          option_name: setting.option_name,
          option_value: setting.option_value
        });
      }
      setSaveSuccess(true);
    } catch (error) {
      console.error("Error saving settings:", error);
      setSaveError("Failed to save settings. Please try again.");
    } finally {
      setIsSaving(false);
     
      setLoading(false);
    
    }
  };

  const handleGifFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type === "image/gif") {
      setGifFile(URL.createObjectURL(file));
    } else {
      alert("Please select a valid GIF file.");
      setGifFile(null);
    }
  };

  const resetColors = () => {
    setPrimaryColor("#0011ff");
    setSecondaryColor("#187d90");
    setTextColor("#ffffff");
    setBgTextColor("#ffffff");
    setAdminPrimaryColor("#0011ff");
    setAdminSecondaryColor("#187d90");
    setAdminTextColor("#ffffff");
  };

  const handleLoginPageFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setLoginPageFile(file);
    }
  };

  const handleFrontPageFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFrontPageFile(file);
    }
  };

  const restoreLoginPageDefault = () => {
    setLoginPageFile(null);
  };

  const restoreFrontPageDefault = () => {
    setFrontPageFile(null);
  };

  const formatDate = (date, formatString) => {
    const parsedDate = typeof date === 'string' ? parse(date, 'd-M-yyyy', new Date()) : date;
    switch (formatString) {
      case "dd-mm-yyyy":
        return format(parsedDate, 'dd-MM-yyyy');
      case "d-mm-yyyy":
        return format(parsedDate, 'd-MM-yyyy');
      case "dd-m-yyyy":
        return format(parsedDate, 'dd-MMMM-yyyy');
      default:
        return format(parsedDate, 'dd-MM-yyyy');
    }
  };

  // if (loading) return (
  //   <div className="flex justify-center items-center h-64">
  //     <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
  //   </div>
  // );

  if (error) return (
    <div className="p-4 text-center text-red-600 bg-red-50 rounded-md">
      Error: {error}
    </div>
  );

  return (
 
    <div className="relative min-h-screen">
    {/* Loading Indicator */}
      {loading && (
           <div className="fixed inset-0 flex items-center justify-center z-50">
             <div className="flex flex-col items-center p-3 bg-black border border-white rounded-2xl">
               <FadeLoader 
                 height={15}
                 width={5}
                 color="#ffffff"
                 ariaLabel="loading"
               />
               <h1 className="mt-1 text-lg text-white">Please wait...</h1>
             </div>
           </div>
         )}
         
         {saveSuccess && (
          <div className="mt-4 p-3 bg-green-100 text-green-700 rounded-md flex items-center">
            <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
            Settings saved successfully!
          </div>
        )}

        {saveError && (
          <div className="mt-4 p-3 bg-red-100 text-red-700 rounded-md flex items-center">
            <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
            {saveError}
          </div>
        )}



    <div className="container mx-auto px-4 md:px-6 lg:px-8  xl:px-24 py-6 ">
      <div className="bg-white shadow-md rounded-lg p-4 md:p-6 mb-6">
        <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4 md:mb-6 border-b pb-2">
          Appearance Settings
        </h2>
        <div className="mt-6 flex justify-center md:justify-end">
          <button 
            className={`bg-green-600 text-white px-6 py-3 rounded-md shadow hover:bg-green-700 transition w-full md:w-auto ${isSaving ? 'opacity-50 cursor-not-allowed' : ''}`}
            onClick={handleSave}
            disabled={isSaving}
          >
            {isSaving ? 'Saving...' : 'Save Settings'}
          </button>
        </div>

        <SettingsCard title=" (User & Staff )Color Scheme">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
            <ColorInput
              label="Primary Color"
              value={primaryColor}
              onChange={(e) => setPrimaryColor(e.target.value)}
            />
            {/* <ColorInput
              label="Secondary Color"
              value={secondaryColor}
              onChange={(e) => setSecondaryColor(e.target.value)}
            /> */}
            <ColorInput
              label="Text Color"
              value={textColor}
              onChange={(e) => setTextColor(e.target.value)}
            />
            {/* <ColorInput
              label="Text Color on bg"
              value={bgTextColor}
              onChange={(e) => setBgTextColor(e.target.value)}
            /> */}
          </div>
        </SettingsCard>

        <SettingsCard title="Admin Area Color Scheme">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            <ColorInput
              label="Primary Color"
              value={adminPrimaryColor}
              onChange={(e) => setAdminPrimaryColor(e.target.value)}
            />
            {/* <ColorInput
              label="Secondary Color"
              value={adminSecondaryColor}
              onChange={(e) => setAdminSecondaryColor(e.target.value)}
            /> */}
            <ColorInput
              label="Text Color"
              value={adminTextColor}
              onChange={(e) => setAdminTextColor(e.target.value)}
            />
          </div>
          <button
            onClick={resetColors}
            className="mt-4 bg-gray-100 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-200 transition"
          >
            Reset Colors
          </button>
        </SettingsCard>

        <SettingsCard title="Booking Options">
          <Toggle
            label="Hide faded already booked time slots"
            isOn={hideBookedTime}
            onToggle={() => setHideBookedTime(!hideBookedTime)}
          />
          <Toggle
            label="Guest user checkout"
            isOn={guestCheckout}
            onToggle={() => setGuestCheckout(!guestCheckout)}
          />
          <Toggle
            label="Existing & new user checkout"
            isOn={existingNewCheckout}
            onToggle={() => setExistingNewCheckout(!existingNewCheckout)}
          />
          <Toggle
            label="Scrollable Cart"
            isOn={scrollableCart}
            onToggle={() => setScrollableCart(!scrollableCart)}
          />
          <Toggle
            label="Display Time Duration on Summary"
            isOn={displayTimeDuration}
            onToggle={() => setDisplayTimeDuration(!displayTimeDuration)}
          />
        </SettingsCard>

        <SettingsCard title="Date & Time Settings">
          <div className="space-y-4">
            <div className="mb-4">
              <label className="block text-sm text-gray-600 mb-2">Time Format</label>
              <select
                value={timeFormat}
                onChange={(e) => setTimeFormat(e.target.value)}
                className="w-full border rounded-md px-3 py-2 bg-white"
              >
                <option value="12">12 Hours</option>
                <option value="24">24 Hours</option>
              </select>
            </div>

            <div className="mb-4">
              <label className="block text-sm text-gray-600 mb-2">Date-Picker Format</label>
              <select
                value={datePickerFormat}
                onChange={(e) => setDatePickerFormat(e.target.value)}
                className="w-full border rounded-md px-3 py-2 bg-white"
              >
                <option value="dd-mm-yyyy">dd-mm-yyyy (eg. {formatDate(new Date(), "dd-mm-yyyy")})</option>
                <option value="d-mm-yyyy">d-mm-yyyy (eg. {formatDate(new Date(), "d-mm-yyyy")})</option>
                <option value="dd-m-yyyy">dd-m-yyyy (eg. {formatDate(new Date(), "dd-m-yyyy")})</option>
              </select>
            </div>

            <div className="mb-4">
              <label className="block text-sm text-gray-600 mb-2">Country Code</label>
              <select
                value={countryCode}
                onChange={(e) => setCountryCode(e.target.value)}
                className="w-full border rounded-md px-3 py-2 bg-white"
              >
                <option>Nothing selected</option>
                <option value="us">United States</option>
                <option value="in">India</option>
                <option value="uk">United Kingdom</option>
                <option value="au">Australia</option>
              </select>
            </div>
          </div>
        </SettingsCard>

        <SettingsCard title="Font Settings">
          <div className="mb-4">
            <label className="block text-sm text-gray-600 mb-2">Frontend Fonts</label>
            <select
              value={font}
              onChange={(e) => setFont(e.target.value)}
              className="w-full border rounded-md px-3 py-2 bg-white"
            >
              <option value="Open Sans">Open Sans</option>
              <option value="Roboto">Roboto</option>
              <option value="Arial">Arial</option>
            </select>
          </div>

          <div className="mb-4">
            <label className="block text-sm text-gray-600 mb-2">Custom CSS</label>
            <textarea
              value={customCss}
              onChange={(e) => setCustomCss(e.target.value)}
              className="w-full border rounded-md px-3 py-2"
              rows="4"
              placeholder="Enter custom CSS here..."
            ></textarea>
          </div>
        </SettingsCard>

        <SettingsCard title="File Uploads">
          <div className="space-y-6">
            <div className="mb-4">
              <label className="block text-sm text-gray-600 mb-2">Login Page Background</label>
              <input
                type="file"
                className="block w-full border rounded-md p-2 text-sm"
                onChange={handleLoginPageFileChange}
              />
              {loginPageFile && (
                <div className="mt-2 flex flex-col sm:flex-row sm:items-center gap-2">
                  <button
                    onClick={restoreLoginPageDefault}
                    className="bg-blue-500 text-white px-4 py-2 rounded-md text-sm"
                  >
                    Restore Default
                  </button>
                  <span className="text-gray-600 text-sm truncate">{loginPageFile.name}</span>
                </div>
              )}
            </div>

            <div className="mb-4">
              <label className="block text-sm text-gray-600 mb-2">Front Page Background</label>
              <input
                type="file"
                className="block w-full border rounded-md p-2 text-sm"
                onChange={handleFrontPageFileChange}
              />
              {frontPageFile && (
                <div className="mt-2 flex flex-col sm:flex-row sm:items-center gap-2">
                  <button
                    onClick={restoreFrontPageDefault}
                    className="bg-blue-500 text-white px-4 py-2 rounded-md text-sm"
                  >
                    Restore Default
                  </button>
                  <span className="text-gray-600 text-sm truncate">{frontPageFile.name}</span>
                </div>
              )}
            </div>
          </div>
        </SettingsCard>

        <SettingsCard title="Loader Settings">
          <div className="space-y-4">
            <div className="mb-4">
              <label className="block text-sm text-gray-600 mb-2">Loader Type</label>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
                <label className="flex items-center p-2 border rounded-md">
                  <input
                    type="radio"
                    value="css"
                    checked={loaderType === "css"}
                    onChange={() => {
                      setLoaderType("css");
                      setCssCode(customCssLoader || "");
                      setShowGifLoader(false);
                      setGifFile(null);
                    }}
                    className="mr-2"
                  />
                  <span>CSS Loader</span>
                </label>
                <label className="flex items-center p-2 border rounded-md">
                  <input
                    type="radio"
                    value="gif"
                    checked={loaderType === "gif"}
                    onChange={() => {
                      setLoaderType("gif");
                      setCssCode("");
                      setShowGifLoader(true);
                    }}
                    className="mr-2"
                  />
                  <span>GIF Loader</span>
                </label>
                <label className="flex items-center p-2 border rounded-md">
                  <input
                    type="radio"
                    value="default"
                    checked={loaderType === "default"}
                    onChange={() => {
                      setLoaderType("default");
                      setCssCode("");
                      setShowGifLoader(false);
                      setGifFile(null);
                    }}
                    className="mr-2"
                  />
                  <span>Default Loader</span>
                </label>
              </div>
            </div>

            {loaderType === "css" && (
              <div className="mb-4">
                <label className="block text-sm text-gray-600 mb-2">
                  Custom CSS Loader
                </label>
                <textarea
                  value={cssCode}
                  onChange={(e) => setCssCode(e.target.value)}
                  className="w-full border rounded-md px-3 py-2"
                  rows="4"
                  placeholder="Enter custom CSS here..."
                ></textarea>
              </div>
            )}

            {loaderType === "gif" && showGifLoader && (
              <div className="mb-4">
                <label className="block text-sm text-gray-600 mb-2">
                  Select GIF Loader
                </label>
                <input
                  type="file"
                  accept="image/gif"
                  onChange={handleGifFileChange}
                  className="w-full border rounded-md p-2"
                />
                {gifFile && (
                  <div className="flex justify-center mt-4">
                    <img
                      src={gifFile}
                      alt="GIF Loader"
                      className="w-16 h-16 object-contain"
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        </SettingsCard>

        <SettingsCard title="Calendar Settings">
          <div className="space-y-4">
            <div className="mb-4">
              <label className="block text-sm text-gray-600 mb-2">
                Calendar Default View
              </label>
              <select
                value={calendarView}
                onChange={(e) => setCalendarView(e.target.value)}
                className="w-full border rounded-md px-3 py-2 bg-white"
              >
                <option value="month">Month</option>
                <option value="agendaWeek">Week</option>
                <option value="agendaDay">Day</option>
              </select>
            </div>

            <div className="mb-4">
              <label className="block text-sm text-gray-600 mb-2">
                Calendar First Day
              </label>
              <select
                value={calendarStartDay}
                onChange={(e) => setCalendarStartDay(e.target.value)}
                className="w-full border rounded-md px-3 py-2 bg-white"
              >
                <option value="0">Sunday</option>
                <option value="1">Monday</option>
              </select>
            </div>
          </div>
        </SettingsCard>

        <div className="mt-6">
          <button 
            className={`bg-green-600 text-white px-6 py-3 rounded-md shadow hover:bg-green-700 transition w-full md:w-auto ${isSaving ? 'opacity-50 cursor-not-allowed' : ''}`}
            onClick={handleSave}
            disabled={isSaving}
          >
            {isSaving ? 'Saving...' : 'Save Settings'}
          </button>
        </div>


      </div>
    </div>
       
  </div>
  );
};

export default Appearance;


